import { type ReactNode } from 'react';

import { PluginsWrapper } from '../../../components/PluginsWrapper';

type Props = { children: ReactNode };

const Infobox = ({ children }: Props) => <PluginsWrapper>{children}</PluginsWrapper>;

export default Infobox;
